import { flow, makeAutoObservable } from 'mobx'

import { openPdfDocumentFromBlob } from 'Shared/utils'

import { STORE_UI } from 'Core/constants'
import { CustomGenerator } from 'Core/interfaces'

import { BiohazardousManifest } from 'Portals/Customer/entities'
import { BiohazardousManifestRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { BiohazardousManifestTable } from './BiohazardousManifestTable'

export class BiohazardousManifestStore {
	table: BiohazardousManifestTable

	constructor(public rootStore: RootStore) {
		this.table = new BiohazardousManifestTable(rootStore)
		makeAutoObservable(this, {}, { autoBind: true })
	}

	@flow
	*downloadDoc(
		docId: BiohazardousManifest.Basic['biohazardousManifestDocumentId'],
		name?: BiohazardousManifest.Basic['manifestDocumentNumber']
	): CustomGenerator<Blob> {
		try {
			const document = yield BiohazardousManifestRepo.downloadDoc(docId)
			openPdfDocumentFromBlob(document, name)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification()
		}
	}
}
